// extracted by mini-css-extract-plugin
export default {"overlay":"ModalAlert_overlay__LQGy9","container":"ModalAlert_container__z1tKo","content":"ModalAlert_content__NIexp","close":"ModalAlert_close__Z466n"};